export const environment = {
  production: true,

  SERVER_URL: 'https://api.att-system.net/api',
  APPLY_URL: 'https://request.gm-system.net/api',
  AUTH_URL: 'https://account.gm-system.net',
  AUTH_SERVER_URL: 'https://account.gm-system.net/api',
  DB_API_URL: 'https://account.gm-system.net/api',
  REDIRECT_URL: 'https://att-system.net'
};
